import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const RoomDay90Page = lazy(() => import("./RoomDay90Page").then((module) => ({ default: module.RoomDay90Page })));

export function RoomDay90Async() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <RoomDay90Page />
    </Suspense>
  );
}
